export default __webpack_public_path__ + "static/media/ETEF-13-14.94972c2c.pdf";